import { api, qs } from '../api';
import { fmtDate } from '../format';
import { go, withQuery } from '../router';
import { useLoad } from '../state';
import { Empty, Loading, PageHead, Pill, Ref, Sub, Tabs } from '../ui/bits';
import { Choice, words } from '../ui/fields';

export function Schedule({ query }: { query: Record<string, string> }) {
  const scope = (query.scope || 'active') as 'active' | 'historical' | 'all';
  const { data, error } = useLoad(() => api('GET', `/schedule?${qs({ scope, q: query.q, owner: query.owner })}`), [JSON.stringify(query)]);
  const rows: any[] = data?.schedule ?? [];
  return (<>
    <PageHead title="Schedule" sub="One row per track with its open step · the workbook's Schedule sheets, live" />
    <Tabs items={[['active', 'Active'], ['historical', 'Historical'], ['all', 'All']]} current={scope} onPick={(s) => go(`#/schedule?scope=${s}`)} />
    <form className="toolbar" key={JSON.stringify(query)} onSubmit={(ev) => { ev.preventDefault(); go(withQuery('#/schedule', ev.currentTarget)); }}>
      <input type="hidden" name="scope" value={scope} />
      <input type="search" name="q" placeholder="Search MID, TID, name" defaultValue={query.q || ''} />
      <Choice name="owner" options={words([...new Set(rows.map((r) => r.owner).filter(Boolean))].sort())} value={query.owner} blank="Any owner" />
      <button className="quiet">Filter</button>
    </form>
    {error ? <Empty>{error}</Empty> : !data ? <Loading /> : rows.length ? (
      <div className="table-wrap"><table><thead><tr><th>TID</th><th>Track</th><th>Last</th><th>Now</th><th>Step start</th><th>Step due</th><th>Planned</th><th>Owner</th></tr></thead><tbody>
        {rows.map((r) => (
          <tr key={r.tid}><td><Ref to={`#/tracks/${r.tid}`}>{r.tid}</Ref><Sub><a href={`#/campaigns/${r.mid}`}>{r.campaign}</a></Sub></td>
            <td>{r.track}<Sub>{r.track_type || ''}{r.channel ? ` · ${r.channel}` : ''}</Sub></td>
            <td>{r.last_status == null ? '—' : <code>{r.last_status}</code>}</td><td><Pill code={r.status_code} /></td>
            <td className="nowrap">{fmtDate(r.step_start)}</td><td className="nowrap">{fmtDate(r.step_end)}</td>
            <td className="nowrap">{fmtDate(r.planned_start)} → {fmtDate(r.planned_end)}</td><td>{r.owner || '—'}</td></tr>
        ))}
      </tbody></table></div>
    ) : <Empty>Nothing in this view.</Empty>}
  </>);
}
